export function canRequestGeolocation() {
  return typeof navigator !== 'undefined' && Boolean(navigator.geolocation)
}

export function requestCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (!canRequestGeolocation()) {
      reject(new Error('geolocation-unavailable'))
      return
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
          recordedAt: new Date().toISOString(),
        })
      },
      (error) => {
        const code = error?.code
        if (code === 1) reject(new Error('geolocation-denied'))
        else if (code === 3) reject(new Error('geolocation-timeout'))
        else reject(new Error('geolocation-unavailable'))
      },
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 },
    )
  })
}

export function formatDistance(meters) {
  if (meters == null || Number.isNaN(Number(meters))) return ''
  const value = Number(meters)
  if (value < 1000) return `${Math.round(value)} m`
  return `${(value / 1000).toFixed(1)} km`
}

export function formatCoordinates(coords, { withAccuracy = true } = {}) {
  if (coords?.lat == null || coords?.lng == null) return ''
  const lat = Number(coords.lat)
  const lng = Number(coords.lng)
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return ''
  const pair = `${lat.toFixed(5)}, ${lng.toFixed(5)}`
  if (!withAccuracy) return pair
  const accuracy = Number(coords?.accuracy)
  if (!Number.isFinite(accuracy)) return pair
  return `${pair} · ±${Math.round(accuracy)} m`
}
